import styled from 'styled-components'
import React from 'react'

export const Container = styled.div`
  position: relative;
  padding: 30px 20px 0px 20px;
`

export const PhotoWrapper = styled.div`
  display: flex;
  justify-content: center;

  svg {
    width: 220px;
    height: 200px;
  }
`

const ProfessionalPhotoStyled = styled.div`
  box-sizing: border-box;
  position: relative;
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;
  object-fit: cover;
  height: 298px;
  width: 314px;
  min-width: 300px;
  border-radius: 7.6px;
`
export const ProfessionalPhoto = (props) => {
  const style = {}
  if (props.bgimage) {
    style.backgroundImage = `url(${props.bgimage})`
  }
  return (
    <ProfessionalPhotoStyled {...props} style={style}>
      {props.children}
    </ProfessionalPhotoStyled>
  )
}

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;

  > h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 42px;
    margin-top: 27px;
    margin-bottom: 0px;
  }
`

export const Divider = styled.div`
  height: 8px;
  background-color: ${props => props.theme.colors.grayDividerColor};
  margin-left: -20px;
  width: calc(100% + 40px);
`

export const ScheduleWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 15px;

  > div {
    padding: 0px;
  }
  h2 {
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 20px;
    margin-top: 0px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  background: ${props => props.theme.colors.backgroundPage};
  padding: 11px 0px 14px 0px;
  border-top: ${props => props.theme.colors.gray200};
  bottom: 0px;
  z-index: 1;

  button {
    height: 44px;
    width: 100%;
    max-width: 300px;
  }

  @media (max-width: 512px) {
    button {
      max-width: 200px;
    }
  }
`
